import {ColConfig, Identifiable, RowConfig} from '@components/common/sandbox/list-view/types'

export const resolveRowValue = <TData extends Identifiable>(row: RowConfig<TData>, col: ColConfig<TData>): any => {
   if (col.renderer) {
      return col.renderer(row)
   }
   return row.data[col.id as keyof TData];
 }